import React from "react";
import { convertMinutesToDHMText } from "../../../../../service/question";
import { isTrue } from "../../../../../service/service";
import Style from "./index.module.scss";

interface BriefInfoProps {
    anonymityFlag: BooleanValue;
    validityTime: number;
    startTime: string;
    endTime: string;
}

export default function BriefInfo({
    anonymityFlag,
    validityTime,
    startTime,
    endTime
}: BriefInfoProps) {
    return (
        <div className={Style.row}>
            <span>活动时长 {convertMinutesToDHMText(validityTime)}</span>
            {startTime && <span>开始时间 {startTime}</span>}
            {endTime && <span>结束时间 {endTime}</span>}
            <span>{isTrue(anonymityFlag) ? "匿名问卷" : "非匿名问卷"}</span>
        </div>
    );
}
